import React, { useEffect, useMemo, useState } from "react";
import Container from "../../components/Layout/Container";
import ContentBlock from "../../components/Layout/ContentBlock";
import HamlSnippet from "../../components/globals/HamlSnippet";

function MarketplaceRulesPage({ match }) {

  return (
    <Container
          location={{
            locationName: "Rules",
            locationUrl: match.url,
          }}
        >
        <HamlSnippet url="/front/marketplace/rules" />
    </Container>
  );
}

export default MarketplaceRulesPage;